import { get } from 'lodash';
import { ssoUrl, redirectUri } from '../../../lib/ssoPath';
import http from '../../../lib/api.service';

import * as actionType from './actionType';

export const commonHeader = {
  'i18n-chain': 'wy',
  'i18n-country': 'CN',
  'i18n-language': 'zh_CN',
  'i18n-source': 'EM',
  'i18n-zone-time': 'UTC+8',
};
const getUserInfo = () => {
  return async dispatch => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: 'GET',
      url: '/users/current',
      headers: { urlPrefix: 'mop-web', ...commonHeader },
    });
    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        userName: get(res, 'data.name', ''),
        userId: get(res, 'data.userId', ''),
        loginStatus: res.message === '成功',
      },
    });

    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: false },
    });
  };
};

const login = code => {
  return async dispatch => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: 'POST',
      url: '/login/oauthLogin',
      headers: {
        urlPrefix: 'mop-web',
        code,
        redirectUri,
        ...commonHeader,
      },
    });

    document.cookie = `token=${get(res, 'data.accessToken', '') || ''}`;
    document.cookie = `refreshToken=${get(res, 'data.refreshToken', '') || ''}`;

    getUserInfo()(dispatch);
  };
};

const logout = () => {
  return async () => {
    document.cookie = 'token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'refreshToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    window.location.href = `https://wysso.wywk.cn/logout?service=${redirectUri}`;
  };
};

export { login, logout, getUserInfo };
